<chart [type]="type" [data]="data" [options]="options"></chart>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/dash-graphic/dash-graphic.component.html